import styled from "styled-components";

import { useMutation } from "@tanstack/react-query";
import { offerPositionUpdate } from "../../../../../services/offers/update-offer-position";
import { toast } from "react-toastify";
import { settings } from "../../../../../helpers/toast.settings";
import { useFormik } from "formik";
import { PricelistOffersGetByIdItems } from "../../../../../services/orders/pricelist-offers-get-by-id/types";
import { StyledButton } from "../../../../../components/Button/button";
import * as yup from "yup";
import { OffersPositionItem } from "../../../../../services/offers/get-all-offers-position/types";
import {
  FilledInput,
  FormControl,
  FormHelperText,
  InputAdornment,
} from "@mui/material";
interface OfferingPositionEditFormProps {
  offerPosition: OffersPositionItem;
}
const OfferingPositionEditForm = ({
  offerPosition,
}: OfferingPositionEditFormProps) => {
  const EditOfferPositionMutation = useMutation(offerPositionUpdate, {
    onSuccess: (res) => {
      toast.success("Edytowano pomyślnie!", {
        toastId: "EditSuccessfully",
        ...settings,
      });
    },
  });
  const validationSchema = yup.object({
    dlugosc: yup
      .number()
      .min(1, "Minimalna wartość to 1")
      .typeError("Błędny format!")
      .required("Długość jest wymagana"),
    szerokosc: yup
      .number()
      .min(1, "Minimalna wartość to 1")
      .typeError("Błędny format!")
      .required("Szerokość jest wymagana"),
    wysokosc: yup
      .number()
      .min(1, "Minimalna wartość to 1")
      .typeError("Błędny format!")
      .required("Wysokość jest wymagana"),
    cena_docelowa: yup
      .number()
      .min(1, "Minimalna wartość to 1")
      .typeError("Błędny format!")
      .required("Cena jest wymagana"),
    ilosc: yup
      .number()
      .min(1, "Minimalna wartość to 1")
      .typeError("Błędny format!")
      .required("Ilość jest wymagana"),
  });
  const formik = useFormik({
    initialValues: {
      cena_docelowa: offerPosition.cena_docelowa,
      ilosc: offerPosition.ilosc,
      dlugosc: offerPosition.dlugosc,
      szerokosc: offerPosition.szerokosc,
      wysokosc: offerPosition.wysokosc,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const body = {
        id_pozycji_oferty: offerPosition.id_pozycji_oferty,
        wymaga_wyceny: offerPosition.wymaga_wyceny,
        usluga: offerPosition.usluga,
        cena_docelowa: formik.values.cena_docelowa,
        obiekt: offerPosition.rodzaj_opakowania,
        ilosc: formik.values.ilosc,
        dlugosc: formik.values.dlugosc,
        szerokosc: formik.values.szerokosc,
        wysokosc: formik.values.wysokosc,
        jednostka_dlugosci: offerPosition.jednostka_dlugosci,
      };

      EditOfferPositionMutation.mutate(body);
    },
  });
  return (
    <PackageTypeSummaryContainer onSubmit={formik.handleSubmit}>
      <>
        {offerPosition.rodzaj_opakowania !== 2 &&
          offerPosition.rodzaj_opakowania !== 3 && (
            <>
              <FormControl
                sx={{ marginTop: "20px", width: "25ch" }}
                variant="filled"
              >
                <StyledSummaryInput
                  id="dlugosc"
                  name="dlugosc"
                  value={formik.values.dlugosc}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.dlugosc && Boolean(formik.errors.dlugosc)
                  }
                  onBlur={formik.handleBlur}
                  type="number"
                  endAdornment={
                    <InputAdornment position="end">mm.</InputAdornment>
                  }
                  aria-describedby="filled-dlugosc-helper-text"
                  inputProps={{
                    "aria-label": "dlugosc",
                  }}
                />
                <FormHelperText id="filled-dlugosc-helper-text">
                  Długoość
                </FormHelperText>
              </FormControl>
              <FormControl
                sx={{ marginTop: "20px", width: "25ch" }}
                variant="filled"
              >
                <StyledSummaryInput
                  id="szerokosc"
                  name="szerokosc"
                  value={formik.values.szerokosc}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.szerokosc && Boolean(formik.errors.szerokosc)
                  }
                  onBlur={formik.handleBlur}
                  type="number"
                  endAdornment={
                    <InputAdornment position="end">mm.</InputAdornment>
                  }
                  aria-describedby="filled-szerokosc-helper-text"
                  inputProps={{
                    "aria-label": "szerokosc",
                  }}
                />
                <FormHelperText id="filled-szerokosc-helper-text">
                  Szerokość
                </FormHelperText>
              </FormControl>
              <FormControl
                sx={{ marginTop: "20px", width: "25ch" }}
                variant="filled"
              >
                <StyledSummaryInput
                  id="wysokosc"
                  name="wysokosc"
                  value={formik.values.wysokosc}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.wysokosc && Boolean(formik.errors.wysokosc)
                  }
                  onBlur={formik.handleBlur}
                  type="number"
                  endAdornment={
                    <InputAdornment position="end">mm.</InputAdornment>
                  }
                  aria-describedby="filled-wysokosc-helper-text"
                  inputProps={{
                    "aria-label": "wysokosc",
                  }}
                />
                <FormHelperText id="filled-wysokosc-helper-text">
                  Wysokość
                </FormHelperText>
              </FormControl>
            </>
          )}

        <FormControl sx={{ marginTop: "20px", width: "25ch" }} variant="filled">
          <StyledSummaryInput
            id="cena_docelowa"
            name="cena_docelowa"
            value={formik.values.cena_docelowa}
            onChange={formik.handleChange}
            error={
              formik.touched.cena_docelowa &&
              Boolean(formik.errors.cena_docelowa)
            }
            onBlur={formik.handleBlur}
            type="number"
            endAdornment={<InputAdornment position="end">zł.</InputAdornment>}
            aria-describedby="filled-cena_docelowa-helper-text"
            inputProps={{
              "aria-label": "cena_docelowa",
            }}
          />
          <FormHelperText id="filled-cena_docelowa-helper-text">
            Cena
          </FormHelperText>
        </FormControl>

        <FormControl sx={{ marginTop: "20px", width: "25ch" }} variant="filled">
          <StyledSummaryInput
            id="ilosc"
            name="ilosc"
            value={formik.values.ilosc}
            onChange={formik.handleChange}
            error={formik.touched.ilosc && Boolean(formik.errors.ilosc)}
            onBlur={formik.handleBlur}
            type="number"
            endAdornment={<InputAdornment position="end">szt.</InputAdornment>}
            aria-describedby="filled-ilosc-helper-text"
            inputProps={{
              "aria-label": "ilosc",
            }}
          />
          <FormHelperText id="filled-ilosc-helper-text">Ilość</FormHelperText>
        </FormControl>
        <SubmitButtonWrapper>
          <StyledButton
            disabled={!formik.isValid}
            type="submit"
            variant="contained"
            sx={{ width: "100%" }}
          >
            Zapisz
          </StyledButton>
        </SubmitButtonWrapper>
      </>
    </PackageTypeSummaryContainer>
  );
};

export default OfferingPositionEditForm;

const PackageTypeSummaryContainer = styled.form`
  width: 50%;
  flex-wrap: wrap;

  @media (max-width: 500px) {
    width: 70%;
  }

  display: flex;
  justify-content: space-between;
  background-color: white;
  padding: 3%;
  border-radius: 10px;
`;
const SubmitButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 20px;
`;
const StyledSummaryInput = styled(FilledInput)(({ theme }) => ({
  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
    display: "none",
  },
  "& input[type=number]": {
    MozAppearance: "textfield",
  },
}));
